import ParentPageReferralCard from './ParentPageAside/components/ParentPageReferralCard';

const ParentPageMobileView = () => {
  return (
    <section className="flex flex-col items-center gap-6 laptop:hidden">
      <ParentPageReferralCard />
    </section>
  );
};

export default ParentPageMobileView;
